export default __webpack_public_path__ + "static/media/logo-nomask.f3f0ab86.svg";